import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon, TrashIcon } from '@heroicons/react/24/outline'
import { PlusIcon, XMarkIcon, PencilSquareIcon, EyeIcon } from '@heroicons/react/24/solid';
import { PRODUCTS } from '../../../../data/Products';

export default function View({ order }) {
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)

  return (
    <>
    <button type="button" onClick={() => setOpen(true)}  className="flex items-center py-2 px-4 rounded hover:bg-gray-100  text-gray-700">
       <EyeIcon className="w-6 h-6"/>
    </button>

    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all md:ml-64 sm:my-8 w-full sm:max-w-2xl">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:mt-0 text-left">
                      <Dialog.Title as="div" className="flex justify-between ">
                        <p className='text-xl font-semibold leading-6 text-gray-900'>Commande {order.id} de {order.customer}</p>
                        <button
                            type="button"
                            className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 sm:mt-0 w-auto"
                            onClick={() => setOpen(false)}
                            ref={cancelButtonRef}>
                            <XMarkIcon className='w-5 h-5 text-gray-900'/>
                        </button>
                      </Dialog.Title>
                      <div className="mt-4">
                        <div action="#" className='w-full'>
                        <ul className="divide-y divide-gray-10">
                            {PRODUCTS.map(( item, index ) => index < 3 && (
                                <li key={item.id} className="flex justify-between gap-x-2 py-2">
                                <div className="flex min-w-0 gap-x-4">
                                    <img className="h-12 w-12 flex-none rounded bg-gray-50" src={item.image} alt="" />
                                    <div className="min-w-0 flex-auto">
                                    <p className="text-sm font-semibold leading-6 text-gray-900">{item.name}</p>
                                    {/* <p className="mt-1 truncate text-xs leading-5 text-gray-500 max-w-xs">{item.description}</p> */}
                                    </div>
                                </div>
                                <div className="shrink-0 flex sm:flex-col sm:items-end">
                                    <p className="text-sm leading-6 text-gray-900">Prix</p>
                                    <p className="text-sm leading-6 text-gray-900">{item.price}$</p>
                                </div>
                                </li>
                            ))}
                            </ul>
                        <div className="flex justify-between items-center py-2">
                            <p className="text-sm text-gray-900">Statut : </p>
                            <p className="text-sm text-gray-900">Prix total : <span className="font-medium">500$</span></p>
                        </div>
                            <div className='flex space-x-2'>
                                <button type="submit" 
                                    className="text-white inline-flex items-center bg-black hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-500 font-medium rounded-lg text-sm px-4 py-1.5 text-center ">
                                  <PencilSquareIcon className="mr-1 -ml-1 w-4 h-4"/>
                                  Changer le statut
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    </>
  )
}
